import {
  AttachmentDocumentFloating as AttachmentImage,
  ApplicationErrorFloating as AttachmentErrorImage,
} from "@rshbintech.dboul/images";
import { useDropzoneContext } from "../../contexts";
import { DICTIONARY } from "../../dictionary";
import { useControlContext } from "../../../control";
import styles from "./dropzone.module.scss";

interface Props {
  isDragging: boolean;
}

export const DropzoneOverlay = ({ isDragging }: Props) => {
  const { isFileLimitExceeded } = useDropzoneContext();
  const { feature } = useControlContext();

  if (!isDragging) {
    return null;
  }

  const getImage = () => {
    if (isFileLimitExceeded || !feature?.chatFileSending) {
      return AttachmentErrorImage;
    }

    return AttachmentImage;
  };

  const getMessage = () => {
    if (isFileLimitExceeded) {
      return DICTIONARY.FILE.MAX_LIMIT;
    }

    if (!feature?.chatFileSending) {
      return DICTIONARY.FILE.DISABLE_SENDING;
    }

    return DICTIONARY.DROPZONE_MESSAGE;
  };

  const Image = getImage();
  const message = getMessage();

  return (
    <div className={styles["dropzone-overlay"]}>
      <div className={styles["dropzone-icon"]}>
        <Image width={64} height={64} />
      </div>
      <div className={styles["dropzone-text"]}>{message}</div>
    </div>
  );
};
